import { render } from "./MedialibraryDetailField.vue?vue&type=template&id=4f19bd59"
import script from "./MedialibraryDetailField.vue?vue&type=script&lang=js"
export * from "./MedialibraryDetailField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/theimer/Developer/laravel/nova-medialibrary-field/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__